const messages = {
  units: {
    points: "b.",
    piecesCount: "{count} ks.",
    piecesCountUnit: "ks.",
  },
  account: {
    title: "Stav účtu",
    noPointsYet: "Zatiaľ žiadne body",
    loading: "Načítava sa stav účtu…",
    lastUpdate: "Posledná aktualizácia: {date}",
    toggleToPurchases: "Zobraziť vaše nákupy",
    toggleToFirstStop: "Zobraziť stav účtu First Stop",
    firstStopPanelButton: "Panel First Stop",
  },
  purchases: {
    title: "VAŠE NÁKUPY",
    carMinimum: "min. 20 ks.",
    busMinimum: "min. 12 ks.",
    bikeMinimum: "min. 10 ks.",
    detailsButton: "Podrobnosti nákupov",
  },
  quickLinks: {
    rules: {
      title: "Pravidlá Vášne",
      subtitle: "a tabuľka príplatkov",
    },
    promotions: {
      title: "Časovo obmedzené akcie",
      subtitle: "a špeciálne kampane",
    },
    knowledge: {
      title: "BRIDGESTONE Go",
      subtitle: "Vedomosti a odmeny",
    },
  },
  bonusUhrd: {
    title: "Bonus UHRD",
    pointsLabel: "+75 b.",
    goalLabel: "Váš cieľ: {count} ks.",
    goalAchievedLabel: "Cieľ dosiahnutý: {count} ks.",
    beyondGoalPointsLabel: "+15 b.",
    beyondGoalPointsPerUnit: "/ks.",
    beyondGoalTotalPointsLabel: "+180",
    beyondGoalTotalPointsUnit: "b.",
    mockGoalAchievedToggle: "Mock: cieľ dosiahnutý",
    detailsButton: "Zistite podrobnosti bonusu",
    regsButton: "Pravidlá",
  },
  bonusUhrdPage: {
    crumbHome: "Domovská stránka",
    crumbBonus: "Bonus UHRD",
    heroHeadline: "Získaj bonusové body za veľké kolesá",
    goalReminderEyebrow: "EŠTE JE TO BLÍZKO",
    goalReminderDaysLeftLead: "Ešte vám ostáva: ",
    goalReminderDaysLeftEmphasis: "{days} dní",
    bonusPeriodLine: "Trvanie akcie: 01.01.2026 – 31.12.2026",
    periodLead: "Trvanie akcie:",
    periodDates: "01.01.2026 – 31.12.2026",
    rulesHeading: "PRAVIDLÁ JEDNODUCHÉ",
    rules: {
      passengerTyres: {
        title: "KUPIUJTE PNEUMATIKY UHRD",
        description:
          "Bonusové body získate za nákup osobných pneumatík 18” a väčších.",
      },
      achieveAdv: {
        title: "DOSIAHNITE SVOJ CIEĽ",
        points: "+75 b.",
        description: "Dosiahnete svoj cieľ, získate prvý bonus:",
      },
      challengeAdv: {
        title: "EŠTE VIAC BODOV!",
        description:
          "Za každú pneumatiku nad cieľom získate +15 b. (maximálne +10 000 b.!)",
      },
      rewardsHighlighted: {
        title: "ODMENY ZA BODY",
        description:
          "Najazdené body je možné uplatňovať v katalógu odmien Bridgestone až podľa uzávierky programu.",
      },
    },
  },
  bonusGoals: {
    title: "Nákupné ciele",
  },
  bonusGoalsPage: {
    crumbHome: "Domovská stránka",
    crumbBonus: "Nákupné ciele",
    heroHeadline: "Realizuj nákupné ciele a zbieraj prémiové body",
    goalReminderEyebrow: "EŠTE JE TO BLÍZKO",
    goalReminderDaysLeftLead: "Ešte vám ostáva: ",
    goalReminderDaysLeftEmphasis: "{days} dní",
    bonusPeriodLine: "Trvanie akcie: 01.01.2026 – 31.12.2026",
    rulesHeading: "PRAVIDLÁ JEDNODUCHÉ",
    rules: {
      passengerTyres: {
        title: "BODY ZA PLNENIE CIEĽOV",
        description:
          "Kategórie a priebehy sú uvedené v komunikácii kampane a v tabuľke doplatkov.",
      },
      achieveAdv: {
        title: "PRVÁ HRANICA",
        points: "+2 000 b.",
        description: "Po prvom prahu vzniká nárok na prémiové body:",
      },
      challengeAdv: {
        title: "VYŠŠIA HRANICA",
        points: "+3 000 b.",
        description:
          "Ďalší limit pridáva ďalšiu prémiu, ako udáva komunikácia kampane:",
      },
      rewardsHighlighted: {
        title: "ODMENY ZA BODY",
        description:
          "Nazbierané body uplatníte v katalógu odmien Bridgestone podľa uzávierky programu.",
      },
    },
  },
  bonusAwansPage: {
    crumbHome: "Domovská stránka",
    crumbBonus: "BONUS ZA POSTUP",
    heroHeadline: "Prekonávajte nákupné prahy — získajte ďalšie prémiové body",
    goalReminderEyebrow: "EŠTE JE TO BLÍZKO",
    goalReminderEyebrowRemaining: "Ešte len",
    goalReminderDaysLeftLead: "Ešte vám ostáva: ",
    goalReminderDaysLeftEmphasis: "{days} dní",
    bonusPeriodLine: "Trvanie akcie: 01.01.2026 – 31.12.2026",
    periodLead: "Trvanie akcie: ",
    periodDates: "01.01.2026 - 31.12.2026",
    periodNote: ". Bonusy sa nesčítajú — dostanete najvyšší dosiahnutý.",
    rulesHeading: "PRAVIDLÁ JEDNODUCHÉ",
    rules: {
      passengerTyres: {
        title: "REALIZUJTE NÁKUPY V PROGRAME",
        description:
          "Postup sa počíta podľa platnej komunikácie kampane a tabuľky doplatkov.",
      },
      achieveAdv: {
        title: "PRVÝ PRÁH POSTUPU",
        points: "+2 000 b.",
        description: "Po dosiahnutí prvého limitu vzniká nárok na prémiové body za postup:",
      },
      challengeAdv: {
        title: "VYŠŠÍ PRÁH POSTUPU",
        points: "+3 000 b.",
        description:
          "Ďalší prah pridáva ďalšiu prémiu podľa podmienok kampane:",
      },
      rewardsHighlighted: {
        title: "ODMENY ZA BODY",
        description:
          "Nazbierané body vymeníte v katalógu odmien po uzavretí obdobia.",
      },
    },
  },
  bonusAwans: {
    title: "BONUS ZA POSTUP",
    detailsButton: "Zistite podrobnosti bonusu",
    mockFirstMilestoneAchievedToggle: "Mock: prvý prah dosiahnutý",
    milestones: {
      goal: {
        pointsLabel: "+2000 b.",
        label: "Váš cieľ: 200 ks.",
        achievedLabel: "Cieľ dosiahnutý: {count} ks.",
      },
      challenge: {
        pointsLabel: "+3000 b.",
        label: "zvládnete to? 400 ks.",
        remainingLabel: "Ešte len {count} ks.",
      },
    },
  },
  analytics: {
    pointsVsLastYear: {
      title: "Získané body vs. minulý rok",
    },
    tiresVsLastYear: {
      title: "Objednané pneumatiky vs. minulý rok",
    },
    purchasesByInch: {
      title: "Nákupy podľa palca",
    },
    purchasesBySupplier: {
      title: "Nákupy podľa veľkoobchodníka",
    },
    view: {
      chart: "Graf",
      table: "Tabuľka",
    },
    legend: {
      lastYear: "minulý rok",
      thisYear: "tento rok",
    },
    tireType: "Typ pneumatiky",
    tireTypes: {
      all: "Všetky",
      passenger: "Osobné",
      truck: "Nákladné",
    },
    downloadXls: "Stiahnuť .xls",
    table: {
      month: "Mesiac",
      label: "Kategória",
      percent: "Podiel %",
    },
    months: {
      jan: "jan",
      feb: "feb",
      mar: "mar",
      apr: "apr",
      may: "máj",
      jun: "jún",
      jul: "júl",
      aug: "aug",
      sep: "sep",
      oct: "okt",
      nov: "nov",
      dec: "dec",
    },
    inch: {
      15: '15"',
      16: '16"',
      17: '17"',
      18: '18"',
      19: '19"',
      20: '20"',
    },
    suppliers: {
      interCars: "Inter Cars",
      handlopex: "Handlopex",
      latex: "Latex",
    },
    surchargeTable: {
      title: "Tabuľka príplatkov",
      diameterHeader: "Priemer pneumatiky",
      andMore: "a viac",
      note1:
        "Tabuľka ukazuje počet bodov udelených za nákup 1 ks pneumatiky podľa značky a priemeru.",
      note2: "Body sa aktivujú po dosiahnutí minimálneho počtu kusov.",
      rulesButton: "Skontrolovať pravidlá",
    },
  },
  promotions: {
    heading:
      "Využite všetky akcie a zbierajte maximálny počet bodov!",
    pageBrandLabel: "Bridgestone Plus",
    pageTitle: "Akcie",
    pageIntro:
      "Prezrite si všetky aktívne akcie, prihláste sa na tie, ktoré to vyžadujú, a maximalizujte body za nákup pneumatík.",
    pageListHeading: "Všetky dostupné akcie",
    filtersAriaLabel: "Filtrovať akcie",
    filterAll: "Všetky",
    filterActive: "Aktívne",
    filterSignInRequired: "Vyžaduje prihlásenie",
    filterSigned: "Prihlásené",
    viewAll: "Zobraziť všetky akcie",
    detailsLink: "Detail akcie",
    backToHome: "Späť na úvodnú stránku",
    backToList: "Späť na zoznam akcií",
    loading: "Načítavanie akcií…",
    listView: "Zobrazenie zoznamu",
    sliderView: "Zobrazenie posuvníka",
    cardButton: "Využiť akciu",
    signInButton: "Prihlásiť sa na akciu",
    signedInButton: "Prihlásené na akciu",
    signInSuccess: "Boli ste prihlásení na akciu.",
    signInError: "Prihlásenie na akciu sa nepodarilo. Skúste to znova.",
    detailDescriptionTitle: "Popis akcie",
    detailRulesTitle: "Pravidlá",
    detailRelatedTitle: "Ďalšie akcie",
    detailRewardLabel: "Odmena",
    detailInfoTitle: "Informácie",
    detailInfoStatus: "Stav",
    detailInfoStart: "Začiatok",
    detailInfoEnd: "Koniec",
    detailInfoBonus: "Bonus",
    detailHelpTitle: "Potrebujete pomoc?",
    detailHelpText:
      "Máte otázky k tejto akcii? Kontaktujte nás.",
    detailHelpContact: "Kontakt",
    detailNoDescription: "Popis akcie nie je k dispozícii.",
    detailPeriod: "Obdobie akcie: {start} – {end}",
    detailAutoApply: "Body sa pripisujú automaticky po nákupe.",
    detailNotFound: "Akcia nebola nájdená.",
    stats: {
      total: "Spolu",
      active: "Aktívne",
      signInRequired: "Vyžaduje prihlásenie",
    },
    status: {
      active: "Aktívna",
      ending_soon: "Čoskoro končí",
      planned: "Pripravujeme",
    },
    pointsLabel: {
      multiply: "x{value} viac bodov",
      add: "+{value} bodov za každú pneumatiku!",
    },
    items: {
      default: {
        description:
          "V tohtoročnej edícii Bridgestone Vášne je až 120 odmien. Stav vášho účtu vám umožňuje uplatniť až 88 z nich!",
      },
      doublePoints: {
        title: "Dvojnásobné body za pneumatiky rady Ecopia Elite 60",
        pointsLabel: "x2 viac bodov",
      },
      purchaseGoal: {
        title: "Extra body za splnenie nákupného cieľa",
        pointsLabel: "+1 bod za každú pneumatiku!",
      },
    },
  },
  rewards: {
    catalogView: "Zobrazenie katalógu",
    sliderView: "Zobrazenie posuvníka",
    slidesAriaLabel: "Snímky katalógu odmien",
    showSlideAriaLabel: "Zobraziť snímok {number}",
    claimButton: "Prevziať odmenu",
    catalogTitle: "Pozrite si celý KATALÓG odmien",
    catalogDescriptionStart:
      "Tento rok máme až 120 odmien. Aktuálny stav účtu vám umožňuje uplatniť",
    catalogDescriptionEnd: "z nich!",
    exchangeButton: "Vymeňte body za odmeny",
    slides: {
      race: {
        title: "Odmena týždňa: deň na pretekárskej dráhe",
        description:
          "Sadnite si za volant tisíckoňového rally monštra. Plyn na podlahu a... ŠTART!",
        points: "1400 b.",
      },
      voucher: {
        title: "Obľúbená odmena: poukaz do Media Expert",
        description:
          "Telefón? Televízor? Niečo do záhrady alebo na terasu? Vymeňte body za skvelé nákupy!",
        points: "od 500 b.",
      },
    },
  },
  benefits: {
    headingStart: "Využite",
    headingHighlight: "všetky",
    headingEnd: "výhody od Bridgestone:",
    tabs: {
      myApps: "Moje aplikácie",
      allApps: "Všetky aplikácie",
    },
    emptyMyApps:
      "Zatiaľ nemáte priradené aplikácie. Prepnite na „Všetky aplikácie“ a požiadajte o prístup.",
    openButton: "Otvoriť",
    items: {
      survey: {
        title: "Dotazník o servise",
        description:
          "Vyplňte dotazník o vašom servise a získajte atraktívnu garantovanú odmenu!",
      },
      collection: {
        title: "COLLECTION",
        description:
          "Vyberte si odmeny z exkluzívneho katalógu produktov a darčekov značky.",
      },
      drive: {
        title: "DRIVE",
        description:
          "Získajte prístup k bohatému multimediálnemu obsahu, ktorý vám pomôže predávať.",
      },
      linkup: {
        title: "LINKUP",
        description:
          "Pozrite sa, ako jednoducho používať European customer care management.",
      },
    },
  },
  footer: {
    ariaLabel: "Pätička",
    links: {
      rules: "Pravidlá programu",
      contact: "Kontakt",
      cookies: "Zásady cookies",
      terms: "Obchodné podmienky",
      privacy: "Zásady ochrany osobných údajov",
      faq: "FAQ",
      e8: "E8",
    },
  },
};

export default {
  messages,
};
